import { useMagic } from "./useMagicLink";
import { deployments } from "@mintkudos/protocol";
import { useAccount, useSignTypedData } from "wagmi";
import { AppEnv, getChainIdFromEnv } from "../config/env";
import { useWallet } from "../services/wallet/useWallet";

/**
 * Generic hook for signing Kudos contract
 */
const useKudosSignature = () => {
  const { signTypedDataAsync } = useSignTypedData();
  const { changeNetwork, provider } = useWallet();
  const { connector } = useAccount();
  const { magicProvider } = useMagic();

  const getKudosSignature = async (types: any, value: any) => {
    let signature: string = "";
    if (provider === "wagmi") {
      try {
        await changeNetwork();

        const chainId = await connector?.getChainId();
        const domain = {
          name: "Kudos",
          chainId: chainId ?? getChainIdFromEnv(),
          verifyingContract: deployments[AppEnv].proxy as `0x${string}`,
        };

        signature = await signTypedDataAsync({ domain, types, value });
      } catch (error: any) {
        // Catches unparseable wagmi error thrown from denying a signature and converts
        // it to a human-readble format that the app can handle higher up.
        if (error.code?.length > 0 && error.code.includes("ACTION_REJECTED")) {
          throw new Error("User rejected request");
        } else {
          throw error;
        }
      }
    } else {
      const domain = {
        name: "Kudos",
        chainId: magicProvider?.network?.chainId ?? getChainIdFromEnv(),
        verifyingContract: deployments[AppEnv].proxy,
      };

      const signer = magicProvider.getSigner();
      signature = await signer._signTypedData(domain, types, value);
    }
    return signature;
  };

  return { getKudosSignature };
};

export default useKudosSignature;
